import {
  Component,
  Input,
  ChangeDetectionStrategy,
  ViewEncapsulation, AfterViewInit
} from '@angular/core';
import { HelpService } from './help.service';

@Component({
  selector: 'td-wb-help-desktop-article',
  templateUrl: 'help-desktop-article.component.html',
  styleUrls: ['help-desktop-article.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None

})
export class HelpDesktopArticleComponent implements AfterViewInit {
  @Input() articleId: string;
  @Input() articleContent: string;
  @Input() hasFocus: boolean;

  constructor(private helpService: HelpService) {
  }

  ngAfterViewInit(): void {
    if (this.hasFocus) {
      this.helpService.scrollToArticle(this.articleId);
    }
  }
}
